export default __webpack_public_path__ + "static/media/about-fablab-1.58fdf89b.jpg";